import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import LearnerActionOptionReview from './ConversationSingleAnswerOptionReview'; //eslint-disable-line import/no-named-as-default
import LearnerActionFeedbackReview from './ConversationSingleAnswerFeedbackReview'; //eslint-disable-line import/no-named-as-default
import QuestionPrompt from '../QuestionPrompt';//eslint-disable-line import/no-named-as-default
import DialogPrompt from '../DialogPrompt';
import BadgeCollect from '../../badges/BadgeCollect';
import * as userDataHelper from '../../../../helpers/userDataHelper';
import * as appHelper from '../../../../helpers/appHelper';
import * as dataHelper from '../../../../helpers/dataHelper';
import * as objectConstants from '../../../../constants/objectConstants';
import * as keyboardConstants from '../../../../constants/keyboardConstants';

class ConversationSingleAnswerReview extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screenObject: this.props.screenObject,
            userData: this.props.userData,
            objectStates: objectConstants.OBJECT_DISPLAY_STATES,
            responseData: this.props.responseData,
            feedbackData: this.props.responseData.latestResponse,
            locale: appHelper.getLocalData(this.props.screenObject),
            showOptions: true,
            showResponse: true,
            showFeedback: true,
            selectedOption: "",
            //badges
            badgesEarned: [],
            checkBadgesEarned: false,
            collected: true,
            character_name: appHelper.isDefined(this.props.callbacks) ? this.props.callbacks.getCharacterName() : appHelper.getScreenCharacterNameByAssetId(this.props.screenObject.asset_id),
            focusedOption: this.props.responseData.latestResponse,
            optionCallbacks: {},
            updateFocus: false,
            allowAudioAutoPlay: false,
            showLabels: true,
            showAnimation: false,
        };
        this.randomiseOptions = this.randomiseOptions.bind(this);
        this.onOptionClick = this.onOptionClick.bind(this);
        this.renderFeedback = this.renderFeedback.bind(this);
        this.renderOptions = this.renderOptions.bind(this);
        //badges
        this.checkBadgeEarnedOnObject = this.checkBadgeEarnedOnObject.bind(this);
        this.getBadge = this.getBadge.bind(this);
        this.getPrevOption = this.getPrevOption.bind(this);
        this.getNextOption = this.getNextOption.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.setOptionCallbacks = this.setOptionCallbacks.bind(this);
        this.setOptionFocus = this.setOptionFocus.bind(this);
    }

    componentDidMount() {
        this.checkBadgeEarnedOnObject();
        this.setOptionCallbacks();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userData !== nextProps.userData) {
            this.setState({
                userData: Object.assign({}, nextProps.userData),
                checkBadgesEarned: true
            });
        }

        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject)
            });
        }
    }

    componentDidUpdate() {
        if (!this.state.showFeedback) {
            this.renderFeedback();
        }

        if (this.checkBadgesEarned) {
            this.checkBadgeEarnedOnObject();
        }

        if (this.state.updateFocus) {
            this.setOptionFocus();
        }
    }

    checkBadgeEarnedOnObject() {
        let params = {
            bite_id: this.state.responseData.bite_id,
            asset_id: this.state.screenObject.asset_id
        };

        let badgesEarned = userDataHelper.checkBadgeEarnedOnObject(this.state.userData, params);
        this.setState({
            checkBadgesEarned: false,
            badgesEarned: Object.assign([], badgesEarned)
        });
    }

    getBadge(badge_id) {
        //return appHelper.getArrayObjectByKey(localStorage.achievements, "code", code);
    }

    renderFeedback() {
        this.setState({showFeedback: true});
    }

    randomiseOptions() {
        this.setState({
            screenObject: Object.assign({}, this.state.screenObject, {
                options: dataHelper.randomiseArray(this.state.screenObject.options)
            })
        });
    }

    onOptionClick(option) {
        this.setState(
            {
                feedbackData: Object.assign({}, option),
                showFeedback: false
            }
        );

        this.refs[`feedback_wrapper_${this.state.screenObject.asset_id}`].focus();
    }

    renderOptions() {
    }


    getPrevOption() {
        let optionIndex = appHelper.getArrayObjectIndexByKey(this.state.screenObject.options, "option_id", this.state.focusedOption.option_id);
        let nextOption = this.state.screenObject.options[optionIndex - 1];
        if (optionIndex <= 0) {
            nextOption = this.state.screenObject.options[this.state.screenObject.options.length - 1];
        }
        this.setState({focusedOption: Object.assign({}, nextOption), updateFocus: true});
    }

    getNextOption() {
        let optionIndex = appHelper.getArrayObjectIndexByKey(this.state.screenObject.options, "option_id", this.state.focusedOption.option_id);
        let nextOption = this.state.screenObject.options[optionIndex + 1];
        if (optionIndex === (this.state.screenObject.options.length - 1)) {
            nextOption = this.state.screenObject.options[0];
        }
        this.setState({focusedOption: Object.assign({}, nextOption), updateFocus: true});
    }

    setKeyboardAccessibility(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.onOptionClick(this.state.focusedOption);

        }

        if (event.which === keyboardConstants.ARROW_LEFT_KEY) {
            event.preventDefault();
            this.getPrevOption();
        }

        if (event.which === keyboardConstants.ARROW_RIGHT_KEY) {
            event.preventDefault();
            this.getNextOption();
        }

        if (event.which === keyboardConstants.ARROW_UP_KEY) {
            event.preventDefault();
            this.getPrevOption();
        }

        if (event.which === keyboardConstants.ARROW_DOWN_KEY) {
            event.preventDefault();
            this.getNextOption();
        }
    }

    setOptionCallbacks() {
        this.setState({
            optionCallbacks: Object.assign({}, this.state.optionCallbacks, {
                setKeyboardAccessibility: this.setKeyboardAccessibility
            })
        });
    }

    setOptionFocus() {
        let focusEl = document.getElementById(`option_review_${this.state.focusedOption.option_id}`);
        focusEl.focus();
        this.setState({updateFocus: false});
    }

    render() {
        return (

            <div className="learner-action">
                {
                    this.state.badgesEarned.length > 0
                        ?
                        <div>
                            {this.state.badgesEarned.map(badge =>
                                <BadgeCollect key={badge.badge_id} badge_id={badge.badge_id}
                                              bite_id={this.state.responseData.bite_id}
                                              asset_id={this.state.responseData.asset_id}
                                              collected={this.state.collected}/>
                            )}
                            <br/>
                        </div>
                        : null
                }
                {this.state.screenObject.prompt_settings.class_name === objectConstants.DIALOG
                    ?
                    <div className="object-container">
                        <DialogPrompt character_name={this.state.character_name}
                                      screenObject={this.state.screenObject}
                                      onComplete={this.renderOptions}
                                      allowAudioAutoPlay={this.state.allowAudioAutoPlay}/>
                    </div>
                    :

                    <QuestionPrompt screenObject={this.state.screenObject} onComplete={this.renderOptions}
                                    allowAudioAutoPlay={this.state.allowAudioAutoPlay}/>

                }
                <div
                    className={`learner-action-option-list user ${this.props.contentData.experience.speech_bubble_corner_style !== null ? this.props.contentData.experience.speech_bubble_corner_style : 'round'}`}
                    role="radiogroup">
                    {this.state.screenObject.options.map(option =>
                        appHelper.isDefined(option)
                            ?
                            <LearnerActionOptionReview key={option.option_id} option={option}
                                                       asset_id={this.state.screenObject.asset_id}
                                                       responseData={this.state.responseData}
                                                       onOptionClick={this.onOptionClick}
                                                       optionReviewId={this.state.feedbackData.option_id}
                                                       focusedOption={this.state.focusedOption}
                                                       optionCallbacks={this.state.optionCallbacks}/>
                            :
                            null
                    )}
                </div>
                <div ref={`feedback_wrapper_${this.state.screenObject.asset_id}`}
                     id={`feedback_wrapper_${this.state.screenObject.asset_id}`} role="button" tabIndex={0}
                     className="feedback-focus">
                    {
                        this.state.showFeedback
                            ? <LearnerActionFeedbackReview option={this.state.feedbackData}
                                                           options={this.state.screenObject.options}
                                                           locale={this.state.locale}
                                                           asset_id={this.state.screenObject.asset_id}
                                                           responseData={this.state.responseData}
                            />
                            : null
                    }
                </div>

            </div>
        );
    }
}

ConversationSingleAnswerReview.propTypes = {
    screenObject: PropTypes.object.isRequired,
    responseData: PropTypes.object.isRequired,
    index: PropTypes.number,
    userData: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    callbacks: PropTypes.object
};

ConversationSingleAnswerReview.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        userData: state.userData,
        contentData: state.contentData
    };
}

export default connect(mapStateToProps)(ConversationSingleAnswerReview);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/conversationSingleAnswer/ConversationSingleAnswerReview.js
 **/